<template>
  <div class="home">
    <div v-if="isAdmin">
      <h2 is="sui-header">Cloud Splash 關鍵字推送</h2>
      <router-link :to="{name:'CreateEvent'}" v-slot="{ href }"><a class="ui primary button" :href="href"><sui-icon name="plus"/>新增</a></router-link>
      <sui-button primary icon="refresh" @click="refresh"/>
      <sui-divider/>
      <sui-menu tabular>
        <router-link :to="{name: 'ManualEvents'}" v-slot="{ href, isExactActive }">
          <sui-menu-item header :href="href" :link="true" :active="isExactActive">手動產生</sui-menu-item>
        </router-link>
        <router-link :to="{name: 'AllEvents'}" v-slot="{ href, isExactActive }">
          <sui-menu-item header :href="href" :link="true" :active="isExactActive">All</sui-menu-item>
        </router-link>
      </sui-menu>
      <router-view :key="$route.fullPath" ref="eventsView"></router-view>
    </div>
    <div v-else-if="isFetchingUserData">
      <sui-dimmer active>
        <sui-loader />
      </sui-dimmer>
    </div>
    <div v-else>
      <AdminHint />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import AdminHint from '@/components/AdminHint.vue'
import { mapState } from 'vuex';

export default {
  name: 'Home',
  computed: {
    ...mapState([
      'isAdmin',
      'isFetchingUserData',
    ]),
  },
  methods: {
    refresh () {
      this.$refs.eventsView.fetchEvents();
    },
  },
  components: {
    AdminHint,
  },
}
</script>
